/* Complete Personal Portfolio Settings for Mohammad Zaid Shaikh */

// Website related settings
const settings = {
  isSplash: true, // Set to false if I don't want Splash screen.
};

// SEO Related settings
const seo = {
  title: "Mohammad Zaid's Portfolio",
  description:
    "High-performing Management Consultant & TPM with expertise in architecting, optimizing, and scaling high-volume generative AI data pipelines and enterprise operational roadmaps.",
  og: {
    title: "Mohammad Zaid Shaikh Portfolio",
    type: "website",
    url: "https://mohammadzaidshaikh.com/",
  },
};

// Home Page / Greeting Section
const greeting = {
  title: "Mohammad Zaid Shaikh",
  logo_name: "MohammadZaidShaikh",
  nickname: "Zaidsk",
  subTitle:
    "High-performing Management Consultant & Technical Program Manager (TPM) with a B.E. in Computer Engineering and proven expertise in architecting, optimizing, and scaling high-volume Generative AI data pipelines, deep learning model workflows (PyTorch/TensorFlow), and MLOps deployments across multi-million dollar global contracts.",
  resumeLink: "https://drive.google.com/file/d/1QlDls8TtInSaaXsxes6RGt8sGxQn0pWc/view?usp=drive_link",
  portfolio_repository: "https://github.com/Zaidsk",
  githubProfile: "https://github.com/Zaidsk",
};

// Social Media Links
const socialMediaLinks = [
  {
    name: "Github",
    link: "https://github.com/Zaidsk",
    fontAwesomeIcon: "fa-github",
    backgroundColor: "#181717",
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/mohammadzaidshaikh56",
    fontAwesomeIcon: "fa-linkedin-in",
    backgroundColor: "#0077B5",
  },
  {
    name: "Gmail",
    link: "mailto:izaid37733@gmail.com",
    fontAwesomeIcon: "fa-google",
    backgroundColor: "#D14836",
  },
];

// Skills Section
const skills = {
  data: [
    {
      title: "AI Data Operations & Voice Pipelines",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Directing 2,000+ hour AI voice data portfolios, engineering ingestion pipelines, and deploying model workflows via PyTorch and TensorFlow",
        "⚡ Managing bilingual code-switching matrices, multi-dialect structures, and model fine-tuning across 50+ global locales",
        "⚡ Architecting operational lifecycles for Voice Cloning pilots, containerized MLOps pipelines, and studio-quality baselines",
        "⚡ Lead adjudicator for tone, speech, and cadence analysis, guiding automated speech engines and REST endpoints to 100% QA acceptance",
      ],
      softwareSkills: [
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: { backgroundColor: "transparent", color: "#3776AB" },
        },
        {
          skillName: "PyTorch",
          fontAwesomeClassname: "simple-icons:pytorch",
          style: { backgroundColor: "transparent", color: "#EE4C2C" },
        },
        {
          skillName: "TensorFlow",
          fontAwesomeClassname: "simple-icons:tensorflow",
          style: { backgroundColor: "transparent", color: "#FF6F00" },
        },
        {
          skillName: "SQL Architecture",
          fontAwesomeClassname: "simple-icons:sqlite",
          style: { backgroundColor: "transparent", color: "#003B5C" },
        },
        {
          skillName: "Power BI",
          fontAwesomeClassname: "simple-icons:powerbi",
          style: { backgroundColor: "transparent", color: "#F2C811" },
        },
        {
          skillName: "Generative AI / LLM",
          fontAwesomeClassname: "simple-icons:openai",
          style: { backgroundColor: "transparent", color: "#412991" },
        },
        {
          skillName: "Docker MLOps",
          fontAwesomeClassname: "simple-icons:docker",
          style: { backgroundColor: "transparent", color: "#2496ED" },
        },
        {
          skillName: "FastAPI",
          fontAwesomeClassname: "simple-icons:fastapi",
          style: { backgroundColor: "transparent", color: "#009688" },
        },
        {
          skillName: "Git Version Control",
          fontAwesomeClassname: "simple-icons:git",
          style: { backgroundColor: "transparent", color: "#F05032" },
        }
      ],
    },
    {
      title: "LLM Fine-Tuning & Alignment Governance",
      fileName: "FullStackImg",
      skills: [
        "⚡ High-volume LLM evaluation workflows, Instruction Fine-Tuning (IFT Part 1 & 2), and constraint analysis",
        "⚡ Executing Safety & Alignment Framework Model (AFM) grading to isolate hallucinations and eliminate bias",
        "⚡ Calibrating multi-turn conversational datasets for contextual personalization and localized tone precision",
        "⚡ High-velocity program delivery, compliance monitoring, and client SLA enforcement",
      ],
      softwareSkills: [
        {
          skillName: "LLM Evaluation",
          fontAwesomeClassname: "simple-icons:openai",
          style: { color: "#10A37F" },
        },
        {
          skillName: "Data Analytics",
          fontAwesomeClassname: "simple-icons:googleanalytics",
          style: { color: "#E37400" },
        },
        {
          skillName: "Advanced Excel",
          fontAwesomeClassname: "simple-icons:microsoftexcel",
          style: { color: "#1D6F42" },
        },
      ],
    },
    {
      title: "Technical Program Management & Corporate Strategy",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Enterprise Automatic Speech Recognition (ASR) platform launch program management and resource allocation",
        "⚡ Designing custom data extraction and ingestion scripts to manage and audit 25+ operational master sheets",
        "⚡ Vendor governance, commercial financial reconciliations, and validation frameworks for external partner agency invoices",
        "⚡ Strategic change governance and bridging ML engineering requirements with global business operations",
      ],
      softwareSkills: [
        {
          skillName: "SQL",
          fontAwesomeClassname: "simple-icons:postgresql",
          style: { color: "#336791" },
        },
        {
          skillName: "Power BI Architecture",
          fontAwesomeClassname: "simple-icons:powerbi",
          style: { color: "#F2C811" },
        },
      ],
    },
  ],
};

// Education Page - Competitive Sites
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "LeetCode",
      iconifyClassname: "simple-icons:leetcode",
      style: {
        color: "#F79F1B",
      },
      profileLink: "https://leetcode.com/",
    },
    {
      siteName: "HackerRank",
      iconifyClassname: "simple-icons:hackerrank",
      style: {
        color: "#2EC866",
      },
      profileLink: "https://www.hackerrank.com/",
    },
    {
      siteName: "Kaggle",
      iconifyClassname: "simple-icons:kaggle",
      style: {
        color: "#20BEFF",
      },
      profileLink: "https://www.kaggle.com/",
    },
  ],
};

// Education Page - Degrees
const degrees = {
  degrees: [
    {
      title: "Rizvi College of Engineering",
      subtitle: "B.E. in Computer Engineering",
      logo_path: "rcoe_logo.png",
      alt_name: "Rizvi College of Engineering",
      duration: "2018 - 2021",
      descriptions: [
        "⚡ Graduated with CGPI: 8.02 / 10.00 in Computer Engineering.",
        "⚡ Core subject matter expertise in Data Structures & Algorithms (DSA), statistical modeling, DBMS, and software architecture.",
        "⚡ Completed technical projects focused on software development and algorithm optimization.",
      ],
      website_link: "https://eng.rizvi.edu.in/",
    },
    {
      title: "Aurangabad College of Engineering",
      subtitle: "Diploma in Computer Science and Engineering",
      logo_path: "acoe_logo.png",
      alt_name: "Aurangabad College of Engineering",
      duration: "2016 - 2018",
      descriptions: [
        "Through my MSBTE Diploma at Aurangabad College of Engineering, I mastered programming languages like Java and C++. I gained hands-on experience in database management, web design, and operating systems. Finally, I built a strong foundation in data structures, computer networks, and software engineering principles.",
      ],
      website_link: "https://aurangabadengg.in/",
    },
  ],
};

// Education Page - Certifications
const certifications = {
  certifications: [
    {
      title: "End-to-End Power BI Architecture",
      subtitle: "- Power BI Reports & Visuals",
      logo_path: "microsoft_logo.png",
      certificate_link: "https://learn.microsoft.com/api/achievements/share/en-us/MOHAMMADZAIDSHAIKH-4512/P5VJ9MF4?sharingId=B5ABA99AA2599521",
      alt_name: "Microsoft",
      color_code: "#D83B0199",
    },
    {
      title: "Machine Learning & AI",
      subtitle: "- Stanford / Coursera",
      logo_path: "stanford_logo.png",
      certificate_link: "",
      alt_name: "Stanford University",
      color_code: "#8C151599",
    },
    {
      title: "Deep Learning Specialization",
      subtitle: "- deeplearning.ai",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link: "",
      alt_name: "deeplearning.ai",
      color_code: "#00000099",
    },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Management Consulting, Technical Program Manager, AI Operations, & Freelance Roles",
  description:
    "A detailed breakdown of my professional journey across Management Consulting, Technical Program Manager, AI Operations, & Freelance Roles.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work Experience",
      work: true,
      experiences: [
        {
          title: "Management Consultant - Technical Program Management & AI Operations",
          company: "Renan Partners Private Limited",
          company_url: "https://www.renan.one/",
          logo_path: "renan_logo.png",
          duration: "June 2025 - Present",
          location: "Remote (Bhiwandi, India)",
          description:
            "Sped up our main AI voice project by 35%. I built custom data workflows in Databrewery to process over 2,000 hours of audio much faster. Helped launch the platform in 50+ regions. I designed systems that could easily handle complex language mixing across Spanish, Portuguese, Arabic, and Indian dialects. Wrote Python scripts to automatically sync and check our project spreadsheets. This cut manual tracking by 40% and stopped data jams. Made sure our voice cloning pilots were 100% legal and technically sound. I set strict audio quality rules and secured all IP rights. Achieved a 100% client acceptance rate. I audited over 500 hours of speech data to make sure the tone and quality were perfect. Kept our global speech recognition project running on schedule by managing daily workflows, tracking goals, and organizing team resources. Tightened up our budget and stopped overspending by closely tracking finances across our 10+ external agency partners.",
          color: "#0879bf",
        },
        {
          title: "AI Training & LLM Evaluation Specialist (Contract)",
          company: "OneForma",
          company_url: "https://www.oneforma.com/",
          logo_path: "oneforma_logo.png",
          duration: "October 2021 - Present",
          location: "Remote",
          description:
            "Enhanced baseline model alignment and safety by logging 110+ hours of high-concentration human-in-the-loop evaluation across Instruction Fine-Tuning (IFT Part 1 & 2) tasks under aggressive timelines. Systematically isolated model hallucinations, bias, and toxic outputs by executing Safety & Alignment Framework Model (AFM Grading) and 0-1 Composition Evaluations. Improved intent parsing accuracy for personalization frameworks by auditing and calibrating multi-turn conversational datasets for localized tone precision and contextual relevance.",
          color: "#0071C5",
        },
        {
          title: "Prompt Writer (Contract)",
          company: "Outlier",
          company_url: "https://outlier.ai/",
          logo_path: "outlier_logo.png",
          duration: "Oct 2024 - Present",
          location: "Remote",
          description:
            "Curated high-quality prompt-image datasets for AI training. Wrote prompts as safe, benign, or harmful for structured extraction and spatial understanding tasks.",
          color: "#0071C5",
        },
        {
          title: "AI Evaluation Specialist (Contract)",
          company: "Alignerr",
          company_url: "https://www.alignerr.com/",
          logo_path: "alignerr_logo.png",
          duration: "Feb 2024 - Jun 2025",
          location: "Remote",
          description:
            "Enhanced AI model performance through rigorous LLM alignment. Focusing on factual accuracy, tone, clarity, and safety. Applied structured testing methods to improve AI's contextual reasoning and instruction-following capabilities.",
          color: "#0071C5",
        },
        {
          title: "Technical Subject Matter Expert (Contract)",
          company: "Chegg Inc.",
          company_url: "https://www.chegg.com/",
          logo_path: "chegg_logo.png",
          duration: "November 2020 - Present",
          location: "Remote",
          description:
            "Delivered 1,000+ high-precision technical solutions in Computer Science, Python, and AI while strictly adhering to authoring guidelines and academic integrity policies. Maintained top-tier quality review ratings by providing clear, step-by-step problem-solving documentation aligned with textbook standards and strict deadlines.",
          color: "#fc1f20",
        },
        {
          title: "Technical Subject Matter Expert (Contract)",
          company: "Course Hero",
          company_url: "https://www.coursehero.com/",
          logo_path: "coursehero_logo.png",
          duration: "June 2023 - Present",
          location: "Remote",
          description:
            "Solved 1,000+ artificial intelligence, database, information technology, etc., problems with 96% accuracy.",
          color: "#fc1f20",
        },
        {
          title: "Technical Subject Matter Expert (Contract)",
          company: "Bartleby Technologies Pvt Ltd.",
          company_url: "https://www.bartleby.com/",
          logo_path: "bartleby_logo.png",
          duration: "February 2022 - July 2023",
          location: "Remote",
          description:
            "Maintained 98% accuracy while resolving 500+ complex academic queries weekly across Computer Science and statistical analysis through rigorous data validation. Reduced content workflow response times by 20% across team operations by engineering Excel-based data tracking automation and standardized problem-solving templates.",
          color: "#fc1f20",
        },
      ],
    },
    {
      title: "Internships",
      experiences: [
        {
          title: "Business Analyst Intern",
          company: "SkillFied Mentor",
          company_url: "https://skillfiedmentor.com/",
          logo_path: "skillfiedmentor_logo.png",
          duration: "January 2025 - Jun 2025",
          location: "Remote",
          description: "Conducted end-to-end store performance analysis, customer segmentation, and optimization. Delivered a 38% improvement in promo targeting, generating a 10-15% uplift in campaign effectiveness using Excel, Power BI, and Python.",
          color: "#0F9D58",
        }
      ]
    }
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "Key initiatives spanning high-volume generative AI voice data pipelines, LLM fine-tuning, automated master sheet data integration, and enterprise speech analytics engines.",
  avatar_image_path: "projects_image.svg",
};

const publicationsHeader = {
  title: "Publications",
  description:
    "Work focused on Generative AI data pipeline architecture, linguistic code-switching matrices, and speech synthesis evaluation benchmarks.",
  avatar_image_path: "projects_image.svg",
};

const publications = {
  data: [],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "animated_zaid.png",
    description:
      "I am available for AI Data Operations Strategy, Technical Program Management (TPM), and Management Consulting roles. Feel free to reach out via email or phone.",
  },
  blogSection: {
    title: "Blogs & Insights",
    subtitle:
      "Articles and notes on scaling AI data ops, LLM alignment frameworks, and multi-dialect speech analytics.",
    link: "https://mohammadzaidshaikh.com/",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Address",
    subtitle: "Bhiwandi, Maharashtra, India",
    locality: "Bhiwandi",
    country: "India",
    region: "Maharashtra",
    postalCode: "",
    streetAddress: "",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://maps.app.goo.gl/RpJkDKPcqAmB3JGA8?g_st=ac",
  },
  phoneSection: {
    title: "Phone Number",
    subtitle: "+91 8087724469",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  publicationsHeader,
  publications,
  contactPageData,
};
